/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import headerConfig from "../config/header.config.json";
import loadingConfig from "../config/loading.config.json";
import errorConfig from "../config/error.config.json";
import notificationConfig from "../config/notifications.config.json";
import paymentQueueConfig from "../config/paymentQueue.config.json";
import placeHolderConfig from "../config/placeHolder.config.json";
import { VApplication } from "../../../application";
import { BreadcrumbService } from "../../breadcrumbService";

import { StorageModule } from "@vlinder-web/storage-module-react";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.BreadcrumbService") as BreadcrumbService;
};

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    const storageService = StorageModule.getInstance();
    const header: any = {};
    try {
      const distCenterData = storageService.get("distCenterData", "local");
      if (distCenterData?.header?.band?.name) {
        header.band = distCenterData?.header?.band?.name;
      }
      if (distCenterData?.header?.counter?.name) {
        header.counter = String(distCenterData?.header?.counter?.name);
      }
      if (distCenterData?.header?.distCenter?.name) {
        header.distCenter = distCenterData?.header?.distCenter?.name;
      }
      if (distCenterData?.paymentCounter) {
        header.distCounterMid = distCenterData?.paymentCounter;
      }
    } catch (err: any) {
      console.log(
        `error in formatQueueHeaderData static error=${err?.message}`
      );
    }
    return {
      header: { ...headerConfig, ...(breadcrumbItems || {}), ...header },
      loading: loadingConfig,
      error: errorConfig,
      notifications: notificationConfig,
      paymentQueue: paymentQueueConfig,
      placeHolderConfig: placeHolderConfig,
    };
  }
}
